/**
 * Copy to clipboard
 * @param {String} value - String to copy
 */
const copyToClipboard = value => {
  navigator.clipboard.writeText(value);
};

export default copyToClipboard;
